import { createFileRoute } from "@tanstack/react-router";
import { ExpoMigrationPage } from "@/components/blocks/services/ExpoMigrationPage";
import { translations } from "@/lib/i18n";
import {
	buildPageBreadcrumb,
	buildPageFaq,
	buildPageSeo,
	buildServiceStructuredData,
	loadPageLocale,
} from "@/lib/page-seo";

export const Route = createFileRoute(
	"/{-$locale}/services/migration-react-native-expo",
)({
	component: ExpoMigrationPage,
	loader: loadPageLocale,
	head: ({ loaderData }) => {
		if (!loaderData) return {};
		const { locale } = loaderData;
		return buildPageSeo("expoMigration", locale, {
			structuredData: [
				buildServiceStructuredData("expoMigration", locale),
				buildPageBreadcrumb(locale, ["expoMigration"]),
				buildPageFaq(translations[locale].expoMigration.faq.items),
			],
		});
	},
});
